import React from 'react';

const PricingPolicy = () => {
  return (
    <div className="policy-page">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="pricing-header text-center">
              <h1>Our Pricing Structure</h1>
              <p>At IBRLIVE, we believe in transparent and fair pricing for our currency exchange API services. Our pricing is designed to scale with your business needs while providing excellent value.</p>
            </div>
          </div>
        </div>

        <div className="row pricing-plans">
          <div className="col-lg-4 col-md-6 mb-4">
            <div className="pricing-card">
              <div className="plan-header">
                <h3>Free Plan</h3>
                <div className="price">Free<span>/month</span></div>
                <p>Free Forever</p>
              </div>
              <div className="plan-features">
                <ul>
                  <li>100 API calls per month</li>
                  <li>Updates every 60 seconds</li>
                  <li>Basic currency pairs</li>
                  <li>One month only</li>
                  <li className="not-included">No technical indicators</li>
                  <li className="not-included">No historical data</li>
                  <li className="not-included">No real-time updates</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 mb-4">
            <div className="pricing-card">
              <div className="plan-header">
                <h3>Basic Plan</h3>
                <div className="price">₹850<span>/month</span></div>
                <p>Perfect for small businesses</p>
              </div>
              <div className="plan-features">
                <ul>
                  <li>35,000 API calls per month</li>
                  <li>Updates every 60 seconds</li>
                  <li>All Currency Pairs</li>
                  <li>Monthly/yearly billing</li>
                  <li className="not-included">No technical indicators</li>
                  <li className="not-included">No historical data</li>
                  <li className="not-included">No real-time updates</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 mb-4">
            <div className="pricing-card popular">
              <div className="popular-badge">Most Popular</div>
              <div className="plan-header">
                <h3>Essential Plan</h3>
                <div className="price">₹8,314<span>/month</span></div>
                <p>Growing businesses with real-time needs</p>
              </div>
              <div className="plan-features">
                <ul>
                  <li>200,000 API calls per month</li>
                  <li>Real-time updates</li>
                  <li>All Currency Pairs</li>
                  <li>Historical data access</li>
                  <li>All APIs (except Technical)</li>
                  <li className="not-included">No technical indicators</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 mb-4">
            <div className="pricing-card">
              <div className="plan-header">
                <h3>Pro Plan</h3>
                <div className="price">₹9,314<span>/month</span></div>
                <p>High-volume trading operations</p>
              </div>
              <div className="plan-features">
                <ul>
                  <li>1,000,000 API calls per month</li>
                  <li>Real-time updates</li>
                  <li>All Currency Pairs</li>
                  <li>Historical data access</li>
                  <li>All APIs (except Technical)</li>
                  <li>High volume support</li>
                  <li className="not-included">No technical indicators</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 mb-4">
            <div className="pricing-card">
              <div className="plan-header">
                <h3>Ultimate Plan</h3>
                <div className="price">₹25,000<span>/month</span></div>
                <p>Enterprise solution with all features</p>
              </div>
              <div className="plan-features">
                <ul>
                  <li>Unlimited API calls</li>
                  <li>Real-time updates</li>
                  <li>All Currency Pairs</li>
                  <li>Technical indicators access</li>
                  <li>Historical data access</li>
                  <li>All APIs available</li>
                  <li>Priority support</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="comparison-section">
              <h3>Plan Features Comparison</h3>
              <div className="features-table">
                <table>
                  <thead>
                    <tr>
                      <th>Feature</th>
                      <th>Free Plan</th>
                      <th>Basic</th>
                      <th>Essential</th>
                      <th>Pro</th>
                      <th>Ultimate</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><strong>API Calls/Month</strong></td>
                      <td>100</td>
                      <td>35,000</td>
                      <td>200,000</td>
                      <td>1,000,000</td>
                      <td>Unlimited</td>
                    </tr>
                    <tr>
                      <td><strong>Update Frequency</strong></td>
                      <td>60 seconds</td>
                      <td>60 seconds</td>
                      <td>3 seconds</td>
                      <td>3 seconds</td>
                      <td>3 seconds</td>
                    </tr>
                    <tr>
                      <td><strong>Currency Pairs</strong></td>
                      <td>Basic</td>
                      <td>All + Metals</td>
                      <td>All + Metals</td>
                      <td>All + Metals</td>
                      <td>All + Metals</td>
                    </tr>
                    <tr>
                      <td><strong>Historical Data</strong></td>
                      <td>❌</td>
                      <td>❌</td>
                      <td>✅</td>
                      <td>✅</td>
                      <td>✅</td>
                    </tr>
                    <tr>
                      <td><strong>Technical Indicators</strong></td>
                      <td>❌</td>
                      <td>❌</td>
                      <td>❌</td>
                      <td>❌</td>
                      <td>✅</td>
                    </tr>
                    <tr>
                      <td><strong>Priority Support</strong></td>
                      <td>❌</td>
                      <td>❌</td>
                      <td>❌</td>
                      <td>❌</td>
                      <td>✅</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-6">
            <div className="info-section">
              <h4>Billing and Payment Terms</h4>
              <ul>
                <li>All plans are billed monthly or yearly</li>
                <li>Free Plan is available for one month only</li>
                <li>Downgrades are not allowed once subscribed</li>
                <li>Upgrades can be done at any time</li>
                <li>Payment is due in advance</li>
                <li>No setup fees or hidden charges</li>
              </ul>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="info-section">
              <h4>Plan Limitations</h4>
              <ul>
                <li><strong>Free Plan:</strong> Limited to 100 API calls, no real-time data</li>
                <li><strong>Basic Plan:</strong> No historical data or technical indicators</li>
                <li><strong>Essential Plan:</strong> No technical indicators</li>
                <li><strong>Pro Plan:</strong> No technical indicators</li>
                <li><strong>Ultimate Plan:</strong> Full access to all features</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="note-section">
              <p><strong>Note:</strong> All prices are subject to change with 30 days notice. Current subscribers will be grandfathered into their existing pricing for 6 months.</p>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .policy-page {
          padding: 60px 0;
          min-height: 80vh;
          background: #f8f9fa;
        }
        
        .pricing-header {
          margin-bottom: 50px;
          padding: 80px 0 0 0;
        }
        
        .pricing-header h1 {
          font-size: 2.5rem;
          font-weight: 700;
          color: #333;
          margin-bottom: 15px;
        }
        
        .pricing-header p {
          font-size: 1.1rem;
          color: #666;
          max-width: 800px;
          margin: 0 auto;
        }
        
        .pricing-plans {
          margin-bottom: 50px;
        }
        
        .pricing-card {
          background: white;
          border-radius: 15px;
          padding: 30px;
          box-shadow: 0 5px 20px rgba(0,0,0,0.1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          height: 100%;
          position: relative;
        }
        
        .pricing-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0,0,0,0.15);
        }
        
        .pricing-card.popular {
          border: 3px solid #007bff;
          transform: scale(1.05);
        }
        
        .popular-badge {
          position: absolute;
          top: -10px;
          right: 20px;
          background: #007bff;
          color: white;
          padding: 5px 15px;
          border-radius: 20px;
          font-size: 0.8rem;
          font-weight: 600;
        }
        
        .plan-header {
          text-align: center;
          margin-bottom: 25px;
          padding-bottom: 20px;
          border-bottom: 2px solid #f0f0f0;
        }
        
        .plan-header h3 {
          font-size: 1.5rem;
          font-weight: 700;
          color: #333;
          margin-bottom: 10px;
        }
        
        .price {
          font-size: 2.5rem;
          font-weight: 700;
          color: #007bff;
          margin-bottom: 5px;
        }
        
        .price span {
          font-size: 1rem;
          color: #666;
          font-weight: 400;
        }
        
        .plan-header p {
          color: #666;
          font-size: 0.9rem;
          margin: 0;
        }
        
        .plan-features ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        
        .plan-features li {
          padding: 8px 0;
          font-size: 0.9rem;
          color: #555;
          border-bottom: 1px solid #f5f5f5;
        }
        
        .plan-features li:last-child {
          border-bottom: none;
        }
        
        .plan-features li.not-included {
          color: #999;
          text-decoration: line-through;
        }
        
        .comparison-section {
          background: white;
          padding: 40px;
          border-radius: 15px;
          box-shadow: 0 5px 20px rgba(0,0,0,0.1);
          margin-bottom: 30px;
        }
        
        .comparison-section h3 {
          font-size: 1.8rem;
          font-weight: 600;
          color: #333;
          margin-bottom: 25px;
          text-align: center;
          border-bottom: 2px solid #007bff;
          padding-bottom: 10px;
        }
        
        .features-table {
          overflow-x: auto;
        }
        
        .features-table table {
          width: 100%;
          border-collapse: collapse;
          margin: 0;
          background: white;
          border-radius: 8px;
          overflow: hidden;
        }
        
        .features-table th {
          background: #007bff;
          color: white;
          padding: 15px 10px;
          text-align: center;
          font-weight: 600;
          font-size: 0.9rem;
        }
        
        .features-table td {
          padding: 12px 10px;
          text-align: center;
          border-bottom: 1px solid #eee;
          font-size: 0.9rem;
        }
        
        .features-table tr:nth-child(even) {
          background: #f8f9fa;
        }
        
        .features-table tr:hover {
          background: #e3f2fd;
        }
        
        .info-section {
          background: white;
          padding: 30px;
          border-radius: 15px;
          box-shadow: 0 5px 20px rgba(0,0,0,0.1);
          height: 100%;
        }
        
        .info-section h4 {
          font-size: 1.3rem;
          font-weight: 600;
          color: #333;
          margin-bottom: 20px;
          border-bottom: 2px solid #007bff;
          padding-bottom: 10px;
        }
        
        .info-section ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        
        .info-section li {
          padding: 8px 0;
          font-size: 0.9rem;
          color: #555;
          border-bottom: 1px solid #f5f5f5;
        }
        
        .info-section li:last-child {
          border-bottom: none;
        }
        
        .note-section {
          background: #e3f2fd;
          padding: 20px;
          border-radius: 10px;
          border-left: 4px solid #007bff;
          margin-top: 20px;
        }
        
        .note-section p {
          margin: 0;
          color: #333;
          font-size: 0.9rem;
        }
        
        @media (max-width: 768px) {
          .policy-page {
            padding: 40px 0;
          }
          
          .pricing-header h1 {
            font-size: 2rem;
          }
          
          .pricing-card {
            padding: 20px;
            margin-bottom: 20px;
          }
          
          .pricing-card.popular {
            transform: none;
          }
          
          .comparison-section {
            padding: 20px;
          }
          
          .info-section {
            padding: 20px;
            margin-bottom: 20px;
          }
          
          .features-table th,
          .features-table td {
            padding: 8px 5px;
            font-size: 0.8rem;
          }
        }
      `}</style>
    </div>
  );
};

export default PricingPolicy;
